import { render, staticRenderFns } from "./PdvTotalDrawer.vue?vue&type=template&id=b08a3366&scoped=true&"
import script from "./PdvTotalDrawer.vue?vue&type=script&setup=true&lang=js&"
export * from "./PdvTotalDrawer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PdvTotalDrawer.vue?vue&type=style&index=0&id=b08a3366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a3366",
  null
  
)

export default component.exports